// Theme management: "system" follows the OS setting; "light" / "dark" force
// a specific theme. The chosen value is stored in localStorage so it persists
// across sessions, and applied by toggling a `dark` class on <html>.
//
// IMPORTANT: a tiny inline script in index.html applies the theme BEFORE this
// module loads, to avoid a flash of light content on page load. This file
// handles runtime updates (when the user picks a new option in Settings).

export type Theme = "system" | "light" | "dark";

const STORAGE_KEY = "pantry.theme";

function prefersDark(): boolean {
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}

function applyTheme(theme: Theme): void {
  const dark = theme === "dark" || (theme === "system" && prefersDark());
  document.documentElement.classList.toggle("dark", dark);
}

export function getTheme(): Theme {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === "light" || stored === "dark" || stored === "system") {
    return stored;
  }
  return "system";
}

export function setTheme(theme: Theme): void {
  localStorage.setItem(STORAGE_KEY, theme);
  applyTheme(theme);
}

// If the user picks "system", we want to follow the OS as it changes.
if (typeof window !== "undefined") {
  const mq = window.matchMedia("(prefers-color-scheme: dark)");
  mq.addEventListener("change", () => {
    if (getTheme() === "system") applyTheme("system");
  });
}
